<template>
  <div class="upload-logo" style="color:#fff;" :style="wh">
    <label for="home-list" style="position:absolute" :style="wh">
      <input
        type="file"
        @change="uploadImg"
        ref="file"
        id="home-list"
        :style="wh"
      />
      <div style="line-height:3">
        <slot></slot>
      </div>
    </label>
    <img
      v-if="imgsrc"
      :src="imgsrc"
      alt=""
      :style="wh"
      class="upload-logo-img"
    />

    <div v-if="imgsrc" class="close" style=" " @click="close('xiao')">╳</div>
  </div>
</template>
<script>
import { uploadimg, upImgForWx } from "../api/index";
import { serviceUploadImg } from "../api/service.js";
import { commonUploadImg, baseUrl } from "../api/common.js";
export default {
  name: "logo",
  data() {
    return {
      imgsrc: "",
      bigsrc: ""
    };
  },
  props: {
    wh: String,
    tag: String,
    base64: Boolean,
    uploadWx: Boolean,
    serviceupload: Boolean,
    identify: Boolean,
    uploadCommon: Boolean
  },
  methods: {
    /**
     * 上传图片
     * @param {*} e
     */
    uploadImg(e) {
      const that = this;
      var media_no = "",
        file_type = "";
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      file_type = e.target.files[0].type.split("/")[1]; //获取文件类型
      reader.onload = async function() {
        that.imgsrc = reader.result;
        if (that.base64 === true) {
          that.$emit("getReturn", {
            imgsrc: reader.result,
            tag: that.tag
          });
          return;
        }
        if (that.uploadCommon === true) {
          const res = await commonUploadImg(
            reader.result.split(",")[1],
            file_type
          );
          if (that.testR(res)) {
            const url = `${baseUrl}/media/image/${res.data.resp_data.media_no}.${file_type}`;
            that.$emit("getReturn", {
              media_no: url,
              tag: that.tag
            });
            return;
          }
          console.log("上传图片：", res);
          // if()
          /*  */
        }
        if (that.uploadWx === true) {
          const res = await upImgForWx(
            e.target.files[0].name,
            reader.result.substring(reader.result.indexOf(",") + 1)
          );
          console.log("上传图片到微信：", res);
          if (res.data.return_code == "Fail" && res.data.return_msg) {
            that.$message.error(res.data.return_msg);
          } else if (res.data.result_code == "FAIL" && res.data.result_msg) {
            that.$message.error(res.data.result_msg);
          } else if (
            res.data.return_code == "SUCCESS" &&
            res.data.result_code == "SUCCESS"
          ) {
            that.$emit("getReturn", {
              imgsrc: JSON.parse(res.data.resp_data).media_url,
              tag: that.tag
            });
          }
          return;
        }
        if (that.serviceupload === true) {
          const res = await serviceUploadImg(that.imgsrc);
          that.$emit("getReturn", {
            media_no: res.data.resp_data.media_no,
            tag: that.tag
          });
          return;
        }
        return;
        const blob1 = new Blob([e.target.files[0]], {
          type: "image/jpeg"
        });
        var { data: res } = await uploadimg(blob1, {
          // access_token: localStorage.getItem("access_token")
          access_token: "7A605334A39E41D5A2986C8A0B7A3178"
        });
        console.log("res", res);
        if (
          res.return_code == "FAIL" ||
          !res.resp_data ||
          res.return_msg == "文件不能大于2M，请重新上传"
        ) {
          that.warnMessage(res.return_msg);
          that.imgsrc = "";
          return;
        }
        if (res.result_code == "FAIL" || !res.resp_data || res.result_msg) {
          that.warnMessage(res.result_msg);
          that.imgsrc = "";
          return;
        }
        if (res.resp_data.media_no) {
          media_no = res.resp_data.media_no;
        } else {
          that.warnMessage("上传照片失败，请重试!!!");
        }
        that.imgsrc = reader.result;
        that.$emit("getReturn", {
          imgsrc: that.imgsrc,
          tag: that.tag,
          media_no
        });
      };
    },
    setImgSrc(src) {
      this.imgsrc = src;
    },
    close(daxiao) {
      if (daxiao == "xiao") {
        this.imgsrc = "";
        this.$refs.file.value = "";
        this.$emit("returnClose", {
          tag: this.tag
        });
      } else {
        this.bigsrc = "";
      }
    }
  }
};
</script>
<style scoped>
.img-icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin-right: 10px;
}
.upload-logo {
  /* width: 60px;
  height: 60px; */
  position: absolute;
  cursor: pointer;
  z-index: 3;
}
.upload-logo-img {
  /* width: 60px;
  height: 60px; */
  position: absolute;
  cursor: pointer;
  z-index: 4;
}
#home-list {
  width: 60px;
  height: 60px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}
.close {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 0px;
  right: 0px;
  text-align: center;
  line-height: 1;
  z-index: 5;
  color: #fff;
  background-color: rgb(249, 96, 96);
}
.close-big {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 0px;
  right: 0px;
  text-align: center;
  line-height: 1;
  background-color: rgb(249, 96, 96);
  border-top-right-radius: 10px;
  font-size: 40px;
}
.big-img {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgb(252, 252, 252);
  border-radius: 10px;
  box-shadow: 0 0 20px #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5;
}
</style>
